export const useStyles = () => {
  return {
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: '16px',
      '@media (max-width: 1023px)': {
        paddingTop: '12px',
      },
      '@media (max-width: 767px)': {
        paddingTop: '8px',
      },
      '@media (max-width: 480px)': {
        paddingTop: '4px',
      },
    },
    buttonsContainer: {
      display: 'flex',
      padding: '8px 0px',
      alignItems: 'center',
      gap: '20px',
      flexWrap: 'wrap',
      justifyContent: 'center',
      '@media (max-width: 1023px)': {
        gap: '16px',
        padding: '6px 0px',
      },
      '@media (max-width: 767px)': {
        gap: '12px',
        padding: '4px 0px',
      },
      '@media (max-width: 480px)': {
        gap: '8px',
        padding: '4px 0px',
      },
    },
    happinessButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        '& .MuiBox-root': {
          opacity: 1,
        },
      },
      '& .MuiBox-root': {
        filter: 'brightness(0) invert(1)',
        opacity: 0.6,
      },
    },
    happinessButtonSelected: {
      backgroundColor: '#FFF',
      '& .MuiBox-root': {
        opacity: 1,
        filter: 'brightness(0.3)',
      },
    },
    smileyIcon: {
      width: '48px',
      height: '48px',
      '@media (max-width: 1023px)': {
        width: '40px',
        height: '40px',
      },
      '@media (max-width: 767px)': {
        width: '36px',
        height: '36px',
      },
      '@media (max-width: 480px)': {
        width: '32px',
        height: '32px',
      },
    },
    selectedValueContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '32px',
      marginTop: '8px',
      '@media (max-width: 1023px)': {
        minHeight: '28px',
        marginTop: '6px',
      },
      '@media (max-width: 767px)': {
        minHeight: '24px',
        marginTop: '4px',
      },
      '@media (max-width: 480px)': {
        minHeight: '20px',
        marginTop: '4px',
      },
    },
    selectedValueText: {
      color: '#FFF',
      fontFamily: 'Noto Sans',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '140%',
      textAlign: 'center',
      '@media (max-width: 1023px)': {
        fontSize: '14px',
      },
      '@media (max-width: 767px)': {
        fontSize: '13px',
      },
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
  };
};
